import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface PreloaderProps {
  children: React.ReactNode;
}

export default function Preloader({ children }: PreloaderProps) {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [displayChildren, setDisplayChildren] = useState(children);

  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => {
      setDisplayChildren(children);
      setLoading(false);
    }, 500);
    return () => clearTimeout(timeout);
  }, [location.pathname, children]);

  return (
    <>
      {loading && (
        <div className="fixed inset-0 z-[100] bg-[#0C1D2E] flex flex-col items-center justify-center transition-opacity duration-300">
          <div className="relative mb-8">
            <img
              src="https://storage.readdy-site.link/project_files/e9e9255d-4fa4-42a2-878c-87b7e92a4901/79b56ce4-7418-4545-880f-043bd4b903d4_Logo-Oficial.png?v=e4ec89a3137073739724e15345a40407"
              alt="IngemetalSur"
              className="h-20 w-auto object-contain animate-pulse"
            />
          </div>
          <div className="w-40 h-[3px] bg-white/10 rounded-full overflow-hidden">
            <div className="h-full bg-[#C88A2A] rounded-full animate-preloader-bar"></div>
          </div>
          <p className="text-white/50 text-xs font-semibold tracking-[0.3em] uppercase mt-5 animate-pulse">
            Cargando
          </p>
        </div>
      )}
      <div className={loading ? 'opacity-0' : 'opacity-100 transition-opacity duration-300'}>
        {displayChildren}
      </div>
    </>
  );
}